core.constant('settingsTranslationPL', {
  "T": {
    "MODULE": {
      "SETTINGS": {
        "LOGIN": "Login",
        "PASSWORD": "Hasło",
        "LAST_EXPORT_DATA": "Ostatni eksport danych",
        "NEW_EXPORT_LOG_DELIVERED": "Dostarczono nowy eksport danych",
        "NEW_EXPORT_LOG_DELIVERED_TEXT": "Zlecenie eksportu danych zostało ukończone. Nowa paczka z danymi w formacie .zip jest do pobrania w widoku Ustawień konta."
      }
    }
  }
});


